export const VIEW_MENU = 'VIEW_MENU'; // afficher menu utilisateur ou la demande de connection
export const HIDE_MENU = 'HIDE_MENU'; // masquer menu utilisateur ou la demande de connection
export const CONNECT_USER = 'CONNECT_USER'; // connection utilisateur
export const DECONNECT_USER = 'DECONNECT_USER'; // deconnecter l'utilisateur
export const UPDATE_USER = 'UPDATE_USER'; // modifier les infos d'un utilisateur
export const UPDATE_USERPW = 'UPDATE_USERPW'; // modifier le mot de passe d'un utilisateur
export const REINIT_USERPW = 'REINIT_USERPW'; // reinitialiser le mot de passe d'un utilisateur
export const INSERT_USER = 'INSERT_USER'; // creer un nouvel utilisateur
export const UPDATE_BIASSE = 'UPDATE_BIASSE'; // modifier les infos de la biasse
export const INSERT_BIASSE = 'INSERT_BIASSE'; // creer une nouvelle biasse / marché
export const DELETE_BIASSE = 'DELETE_BIASSE'; // supprimer une Biasse
export const INSERT_ARTICLE = 'INSERT_ARTICLE'; // ajouter un article a la vente
export const UPDATE_ARTICLE = 'UPDATE_ARTICLE'; // modifier un article  a la vente
export const UPDATE_CDESLIGNES = 'UPDATE_CDESLIGNES'; // modifier ou ajouter une pre-commande
